<script>
  // your script goes here
</script>

<h3>Classic Stocked Items</h3>
<div class="feature">
  <div class="icon">
    <img src="img/icons/shipped.svg" alt="shipping" />
  </div>
  <div class="text">
    <p>7-10 Day Delivery</p>
  </div>
</div>
<div class="feature">
  <div class="icon">
    <img src="img/icons/tshirt-stocked.svg" alt="stocked items" />
  </div>
  <div class="text">
    <p>Choose From a Range of Stocked Items</p>
  </div>
</div>
<div class="feature">
  <div class="icon">
    <img src="img/icons/heat-press.svg" alt="digital print" />
  </div>
  <div class="text">
    <p>Add Quality Digital Print or Embroidery</p>
  </div>
</div>
<div class="feature">
  <div class="icon">
    <img src="img/icons/muscle.svg" alt="durable" />
  </div>
  <div class="text">
    <p>Durable & High Contrast</p>
  </div>
</div>
<div class="feature">
  <div class="icon">
    <img src="img/icons/fiber.svg" alt="fabric" />
  </div>
  <div class="text">
    <p>Range of Fabric Options: Cotton, Poly, Blend</p>
  </div>
</div>

<style>
  h3 {
    color: #1b285d;
    text-transform: uppercase;
    line-height: 4rem;
    padding-top: 2rem;
  }

  .feature {
    display: flex;
    align-self: flex-start;
    align-items: center;
    margin-top: 2rem;
    margin-left: 4rem;
  }

  .icon {
    background: #fe5900;
    padding: 0.4rem;
    border-radius: 5px;
    margin-right: 1rem;
  }

  img {
    width: 4rem;
    height: 4rem;
  }

  .text {
    font-size: 1.6rem;
    font-weight: 600;
    color: #464646;
  }
</style>
